// utils
import { PAD_ITEM_TYPE } from 'app/config/pad_item';
// class
import PadItemEquipment from 'app/redux/reducers/pad-model-editor/components-js/pad-item/equipment/PadItemEquipment';

const TEMPLATE_NAME = 'PAD_MODEL_EDITOR_ITEM_EQUIPMENT';

const initialState = () => ({
  loading: false,
  errors: [],
  data: {
    loaded: [],
    screen: [],
    submit: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      const padItemEquipments = newData;
      const padItemEquipment = new PadItemEquipment(state);

      // prettier-ignore
      return padItemEquipment
            .prepare(padItemEquipments, PAD_ITEM_TYPE.EQUIPMENT)
            .setLoading(false)
            .getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const newData = action.payload;
      const padItemEquipment = newData.data;

      return new PadItemEquipment(state).add(padItemEquipment).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const newData = action.payload;
      const padItemEquipment = { ...newData.data };

      return new PadItemEquipment(state).edit(padItemEquipment).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const newData = action.payload;
      const padItemEquipment = newData.data;

      return new PadItemEquipment(state).remove(padItemEquipment).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
